<div class="container" *letVar="feed$ | async as feed">
    <ng-container *ngIf="feed; else noFeed">
        <ng-container *ngFor="let item of feed | callback: filterRSSByDate">
            <div class="rssItem">
                <div class="rssItem__header">
                    <span class="rssItem__header__title">{{ item.title }}</span>
                    <span class="rssItem__header__subtitle">{{ item.pubDate | date: "MMM dd, yyyy" }}</span>
                    <a [href]="item.link" rel="noopener noreferrer" target="_blank">
                        <button class="rssItem__header__button" mat-stroked-button>Explore this feature</button>
                    </a>
                </div>
                <div>
                    {{ extractDescriptionText(item) }}
                </div>
            </div>
        </ng-container>
        <div *ngIf="feed && (feed | callback: filterRSSByDate).length === 0">No news within the last 90 days</div>
    </ng-container>
</div>

<ng-template #noFeed>
    <div>Unable to load Dealer News</div>
</ng-template>
